// src/utilities/phoneCodes.js

export const phoneCodeOptions = [
  { code: "+56", label: "Chile", flag: "🇨🇱" },
  { code: "+54", label: "Argentina", flag: "🇦🇷" },
  { code: "+51", label: "Perú", flag: "🇵🇪" },
  { code: "+55", label: "Brasil", flag: "🇧🇷" },
  { code: "+598", label: "Uruguay", flag: "🇺🇾" },
  { code: "+591", label: "Bolivia", flag: "🇧🇴" },
  { code: "+595", label: "Paraguay", flag: "🇵🇾" },
  { code: "+57", label: "Colombia", flag: "🇨🇴" },
  { code: "+58", label: "Venezuela", flag: "🇻🇪" },
  { code: "+52", label: "México", flag: "🇲🇽" },
  { code: "+1", label: "Estados Unidos", flag: "🇺🇸" },
  { code: "+1", label: "Canadá", flag: "🇨🇦" },
  { code: "+34", label: "España", flag: "🇪🇸" },
  { code: "+39", label: "Italia", flag: "🇮🇹" },
];

// Template visual para mostrar bandera + nombre + código
export const phoneCodeOptionTemplate = (option) => {
  if (!option) return null;
  return (
    <div className="flex align-items-center gap-2">
      <span style={{ fontSize: "1.2rem" }}>{option.flag}</span>
      <span>{option.label}</span>
      <span className="text-sm text-color-secondary">{option.code}</span>
    </div>
  );
};
